import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { title: '邮件满意度--携手为儿童' },
    component: HomeView
  }
]

const router = new VueRouter({
  routes,
  mode: "history",
  base: "/survey/edmsurvey",
})

router.beforeEach((to, from, next) => {
  to.meta.title && (document.title = to.meta.title);
  next();
});
export default router
